module.exports = __webpack_public_path__ + "static/img/200173.b38d2a64.png";